import styled from 'styled-components';

export const Container = styled.div`
  height: calc(100vh - 8rem);
  width: 100%;
  margin-top: 4rem;
  background-color: var(--gray-background);

  @media (max-width: 850px) {
    height: calc(100vh - 4rem);
  }
`;

export const Content = styled.div`
  padding: 2rem 10rem;
  max-width: 100%;
  justify-content: space-between;
  max-height: calc(100vh - 8rem);

  @media (max-width: 850px) {
    padding: 2rem;
    header { 
      gap: 0;
      a {
        &:last-child {
          margin-left: 1rem;
        }
      }
    }
  }

  header {
    display: flex;
    gap: 2rem;
    max-width: 1400px;
    margin: 0 auto;
    a {
      display: inline-block;
      color: var(--light-blue);
      text-decoration: none;
      background-color: #FFF;
      border-radius: 4px;
      border: 1px solid rgba(0,0,0,0.125);
      border-bottom: 3px solid  rgba(0, 0, 0, 0.025);
      -webkit-box-shadow: rgba(0, 0, 0, 0.3) 0 1px 3px;
      -moz-box-shadow: rgba(0,0,0,0.3) 0 1px 3px;
      box-shadow: rgba(0, 0, 0, 0.3) 0 1px 3px;

      .flex-div {
        height: 100%;
        padding: 0.4rem 1rem;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      &::after {
        content: '';
        display: block;
        width: 0;
        height: 3px;
        background: var(--light-blue);
        transition: width .3s;
      }

      &:hover::after {
        width: 100%;
      }

      &:first-child {
        border-bottom: 3px solid var(--light-blue);
      }
    }
    
    h2 {
      font-size: 1.4rem;
    }

    img {
      width: 100%;
      max-width: 2.4rem;
      margin-right: 1rem;
    }
  }
  
  .body {
    padding: 2rem 0;
    width: 100%;

    strong {
      color: var(--dark-blue);
    }
    p {
      max-width: 1400px;
      margin: 0 auto;
    }
    .loader-div {
      position: absolute;
      top: 50%;
      left: calc(50% - 40px);
    }

    .first-line-body {
      display: flex;
      max-width: 1400px;
      margin: 0 auto;
      align-items: center;
      justify-content: space-between;

      button {
        padding: 0.2rem 1rem;
      }
    }

    .scroll-body {
      margin: 1rem auto;
      padding-right: 1rem;
      width: 100%;
      height: calc(100vh - 22rem);
      overflow-x: hidden;
      overflow-y: auto;
      display: flex;
      flex-direction: column;

      p {
        font-size: 1.5rem;
        text-align: center;
        margin-top: 2rem;
      }

      @media (max-width: 850px) {
        padding-right: 0;
      }

      #childrens-table {
        margin: 0 auto;
        border-collapse: collapse;
        width: calc(100% + .5rem);
        max-width: calc(1400px);
        -webkit-box-shadow: rgba(0, 0, 0, 0.6) 0 4px 4px;
        -moz-box-shadow: rgba(0,0,0,0.3) 0 4px 4px;
        box-shadow: rgba(0, 0, 0, 0.3) 0 4px 5px;
        animation: fade 1s;
         
         thead {
            border-collapse: collapse;
         }

        tr {
          &:nth-child(even){
            background-color: #fff;
          }
          &:hover {
            background-color: var(--light-green);
            color: #FFF;
            cursor: pointer;
          }
          
        }

        td, th { 
          padding: 8px;
          text-transform: capitalize;
        }

        th {
          cursor: default;
          padding-top: .5rem;
          padding-bottom: .5rem;
          text-align: left;
          font-size: 1.2rem;
          background-color: var(--light-blue);
          color: white;
          position: -webkit-sticky; // this is for all Safari (Desktop & iOS), not for Chrome
          position: sticky;
          top: 0;
          z-index: 0;
        }

        @media (max-width: 850px) {
          width: 98%;
          font-size: 0.8rem;

          th {
            font-size: .8rem;
          }
        }
      }
    }
  }
`;